(function () {
    'use strict';

    angular
        .module('app.eventDisplay')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'eventdisplay',
                  config: {
                      abstract: true,
                      url: '/eventdisplay',
                      template: '<ui-view/>'
                  }
              },
            {
                state: 'eventdisplay.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/eventDisplay/list.html?v=' + opsIncludeVersion,
                    controller: 'EventDisplayListController',
                    controllerAs: 'vm',
                    title: 'Event Display Types',
                    settings: {
                        authMode: 1
                    },
                    resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            },
            {
             state: 'eventdisplay.details',
             config: {
                 url: '/detail/:id',
                 templateUrl: 'app/eventDisplay/details.html?v=' + opsIncludeVersion,
                 controller: 'EventDisplayDetailsController',
                 controllerAs: 'vm',
                 title: 'Event Display Details',
                 settings: {
                     authMode: 1
                 },
                 resolve: {
                     authenticationRequired: ['userService', function (userService) {
                         if (userService.userType() == "0") {
                             throw { name: "NotAdmin" };
                         }
                     }]
                 }
             }
            },
            {
                state: 'eventdisplay.display',
                config: {
                    url: '/display/:id',
                    templateUrl: 'app/eventDisplay/display.html?v=' + opsIncludeVersion,
                    controller: 'EventDisplayController',
                    controllerAs: 'vm',
                    title: 'Event Display'
                }
            }
          
        ];
    }
})();
